import React from "react" ;
import { Link } from "react-router-dom";

import "../../styles/UI/resourceCard.scss";
import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";

const ResourceCard = (props) => {
    const iconUrl = getDocumentUrl(props.icon_id, 200, true);

    const resourceUrl = () => {
        let url = '';

        if (props.link !== '')
        {
            url = props.link;
        }
        else
        {
            url = '/getFile.php?enc_docid=' + props.document_id;//getDocumentUrl(props.document_id, 200, true);
        }

        return url;
    }

    const openInNewTab = (url) => {
        var win = window.open(url(), '_blank');
        win.focus();
    }

    return (
        <article onClick={() => openInNewTab(resourceUrl)} className="article-card">
            {/* {console.log(resourceUrl())} */}
            <figure className="article-image">
                <img src={iconUrl} alt={props.name}/>
            </figure>
            <div className="article-content">
                {props.date && <span className="card-category">{props.date}</span>}
                <h3 className="card-title">{props.name}</h3>
                <p className="card-excert">{props.description}</p>
            </div>
        </article>
    );
}

export default ResourceCard;
